import { useLanguage } from "@/contexts/LanguageContext";

export function AppFooter() {
  const { language } = useLanguage();
  
  return (
    <footer className="border-t bg-card/50 backdrop-blur-sm py-4 mt-auto">
      <div className="container mx-auto px-4 text-center">
        <p className="text-xs text-muted-foreground">
          {language === 'hi' 
            ? '© 2025 दम्यन्ती बाग - मोटाभाई का वर्ग. सर्वाधिकार सुरक्षित।' 
            : '© 2025 દમયંતી બાગ - મોટાભાઈ નો વર્ગ. All rights reserved.'}
        </p>
        <a 
          href="https://www.hofficecrm.com" 
          target="_blank" 
          rel="noopener noreferrer"
          className="inline-block mt-2 text-xs font-medium text-neutral-500 hover:text-primary transition-colors"
        >
          Powered by H-Office CRM
        </a>
      </div>
    </footer>
  );
}
